import { render, staticRenderFns } from "./DocumentsAndWebpagesStep.vue?vue&type=template&id=319e967d&scoped=true&"
import script from "./DocumentsAndWebpagesStep.vue?vue&type=script&lang=js&"
export * from "./DocumentsAndWebpagesStep.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsAndWebpagesStep.vue?vue&type=style&index=0&id=319e967d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e967d",
  null
  
)

export default component.exports